module.exports = __webpack_public_path__ + "static/cigna-6b039df380325cad8480ee865c04e914.jpg";